import { jsx as c } from "react/jsx-runtime";
import { useTheme as E, Box as y, Paper as L, CircularProgress as T } from "@mui/material";
import { useRef as Y, useState as m, useEffect as p } from "react";
import { useApp as w } from "../../context/app/index.js";
import C from "@mui/icons-material/Refresh";
const A = ({ onPullComplete: h }) => {
  const r = Y(null), [n, a] = m(0), [t, u] = m(!1), { mainEl: e } = w(), v = E(), i = 150;
  p(() => {
    if (e) {
      const o = (s) => {
        e.scrollTop == 0 && (r.current = s.touches[0].clientY);
      }, f = (s) => {
        if (r.current !== null) {
          const l = s.touches[0].clientY - r.current;
          l > 0 && (a(l), l > 10 && s.preventDefault());
        }
      }, d = () => {
        n >= i && u(!0), r.current = null, a(0);
      };
      return e.addEventListener("touchstart", o, { passive: !1 }), e.addEventListener("touchmove", f, { passive: !1 }), e.addEventListener("touchend", d), () => {
        e.removeEventListener("touchstart", o), e.removeEventListener("touchmove", f), e.removeEventListener("touchend", d);
      };
    }
  }, [e, n]), p(() => {
    t && (h(), setTimeout(() => {
      u(!1);
    }, 1e3));
  }, [t]);
  const x = n > i ? 100 : n / i * 100;
  return /* @__PURE__ */ c(y, { sx: (o) => ({
    position: "fixed",
    top: 0,
    zIndex: o.zIndex.drawer + 1,
    width: "100vw",
    display: "flex",
    flexFlow: "column",
    justifyContent: "center",
    alignItems: "center",
    transform: `translateY(-${t ? 0 : 100 - x}%)`,
    opacity: t ? "0" : "1",
    transition: "opacity 1s",
    pt: 4
  }), children: /* @__PURE__ */ c(L, { variant: "translucent", sx: { p: 1, borderRadius: "50%", display: "flex", justifyContent: "center", alignItems: "center" }, children: t ? /* @__PURE__ */ c(T, { size: 23 }) : /* @__PURE__ */ c(C, { sx: { color: v.palette.primary.main }, width: 23, height: 23 }) }) });
};
export {
  A as PullActionHandler
};
//# sourceMappingURL=index.js.map
